import { render } from "./Wood.vue?vue&type=template&id=593fc0bf"
import script from "./Wood.vue?vue&type=script&lang=js"
export * from "./Wood.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/productionOverview/Wood.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "593fc0bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('593fc0bf', __exports__)) {
    api.reload('593fc0bf', __exports__)
  }
  
  module.hot.accept("./Wood.vue?vue&type=template&id=593fc0bf", () => {
    api.rerender('593fc0bf', render)
  })

}


export default __exports__